<template>
  <iframe :src="iframe_uri" class="iframe" :style="{ height: maxHeight + 'px', width: maxWidth + 'px' }"></iframe>
</template>
<script>
String.prototype.trim = function (char, type) {
  if (char) {
    if (type == 'left') {
      return this.replace(new RegExp('^\\' + char + '+', 'g'), '');
    } else if (type == 'right') {
      return this.replace(new RegExp('\\' + char + '+$', 'g'), '');
    }
    return this.replace(new RegExp('^\\' + char + '+|\\' + char + '+$', 'g'), '');
  }
  return this.replace(/^\s+|\s+$/g, '');
};

export default {
  name: "iframe_mod",
  data() {
    return {
      iframe_uri: "",
      maxHeight: 400,
      maxWidth: 400
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.maxHeight = window.innerHeight - 95;
      this.maxWidth = window.innerWidth > 680 ? window.innerWidth - 215 : window.innerWidth;
    });
    window.onresize = () => {
      return (() => {
        this.$nextTick(() => {
          this.maxHeight = window.innerHeight - 95;
          this.maxWidth = window.innerWidth > 680 ? window.innerWidth - 215 : window.innerWidth;
        })
      })()
    }
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    let that = this;
    let description = null;
    try {
      routers.forEach(item => {
        if (!description && item.path.indexOf("/iframe_mod_") == 0 && item.path == that.$route.path) {
          description = item.description
          throw Error()
        }
        if (item && item.children && item.children.length > 0) {
          item.children.forEach(itemd => {
            if (!description && itemd.path.indexOf("/iframe_mod_") == 0 && itemd.path == that.$route.path) {
              description = itemd.description
              throw Error()
            }
          })
        }
      });
    } catch (err) {
      if (err.message === 'End Loop') throw err
    }
    var uri = new URL(description);
    if (localStorage.getItem("user"))
      uri.searchParams.set('u_id', JSON.parse(localStorage.getItem("user")).uID);
    if (localStorage.getItem("organization_id"))
      uri.searchParams.set('u_org_id', localStorage.getItem("organization_id").trim().trim('"'));
    if (localStorage.getItem("uRealName"))
      uri.searchParams.set('u_name', localStorage.getItem("uRealName").trim().trim('"'));
    that.iframe_uri = uri.href;
    console.log(that.iframe_uri);
  },
};
</script>
<style >
.iframe {
  position: fixed;
  top: 96px;
  width: 100%;
  border: none;
  z-index: 2;
}
</style>
